import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { acceptAppTeamInvite } from "@/request/team";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import useDialog from "@/hooks/useDialog";
import { useRouter } from "vue-router";
export default /*@__PURE__*/_defineComponent({
  __name: 'AcceptMember',
  setup(__props, {
    expose: __expose
  }) {
    const {
      isShow,
      openDialog,
      closeDialog,
      rowData
    } = useDialog({});
    const router = useRouter();
    const inviteId = router.currentRoute.value.query.inviteId;
    // 提交
    const submit = async () => {
      var _res$data;
      let param = {
        inviteId: inviteId
      };
      if (!inviteId) {
        ElMessage.error('邀请链接无效');
        return;
      }
      const res = await acceptAppTeamInvite(param);
      if ((res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) == 200) {
        var _res$data2;
        let teamId = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data;
        console.log(teamId);
        ElMessage.success('加入团队成功');
        router.push({
          path: "team-manage/1",
          query: {
            choiceTeamId: teamId
          }
        }).then(() => {
          // 重新刷新页面
          location.reload();
        });
      }
    };
    __expose({
      openDialog
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modal: false,
        "close-on-press-escape": false,
        "close-on-click-modal": false,
        width: "30vw",
        "model-value": true,
        center: "",
        "destroy-on-close": "",
        "show-close": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("接受")])),
          _: 1
        })])]),
        default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "content"
        }, [_createElementVNode("div", null, "邀请您加入团队 "), _createElementVNode("p", {
          style: {
            "color": "#8D9095"
          }
        }, [_createTextVNode("链接有效期: "), _createElementVNode("span", {
          style: {
            "color": "#2878FF"
          }
        }, "14 天")])], -1))]),
        _: 1
      });
    };
  }
});